import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetchWrapper } from "_helpers";
import { StringExtensions } from "../_helpers/extensions";

// create slice

const name = "notifications";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

export const notificationsActions = { ...slice.actions, ...extraActions };
export const notificationsReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    notifications: {
      office: {
        items: [],
        paging: {},
      },
      driver: {
        items: [],
        paging: {},
      }
    },
  };
}

function createReducers() {
  return { setSorting };

  function setSorting(state, action) {
    state.notifications.sorting = action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/notifications`;

  return {
    getAll: getAll(),
    update: update(),
  };

  function getAll() {
    return createAsyncThunk(
      `${name}/getAll`,
      async(payload) => {
        const queryString = StringExtensions.createQueryStringFromObject(payload);
        return await fetchWrapper.get(`${baseUrl}${queryString}`);
      });
  }

  function update() {
    return createAsyncThunk(
      `${name}/update`,
      async ({ id, payload }) => {
        return await fetchWrapper.patch(`${baseUrl}/${id}`, payload);
      }
    );
  }
}

function createExtraReducers() {
  return {
    ...getAll(),
    ...update(),
  };

  function getAll() {
    var { pending, fulfilled, rejected } = extraActions.getAll;
    return {
      [pending]: (state, action) => {
        const { originatorType } = action.meta.arg;
        const key = originatorType.toLowerCase();
        state.notifications[key].items = { loading: true };
      },
      [fulfilled]: (state, action) => {
        const { items, ...paging } = action.payload;
        const { originatorType } = action.meta.arg;
        const key = originatorType.toLowerCase();

        state.notifications[key].items = items;
        state.notifications[key].paging = paging;
      },
      [rejected]: (state, action) => {
        const { originatorType } = action.meta.arg;
        const key = originatorType.toLowerCase();

        state.notifications[key].items = { error: action.error };
      },
    };
  }

  function update() {
    var { fulfilled } = extraActions.update;
    return {
      [fulfilled]: (state, action) => {
        const { id, key } = action.meta.arg;
        const updatedNotification = state.notifications[key].items.find((x) => x.id === id);
        Object.assign(updatedNotification, { isRead: true });
        state.notifications[key].paging.totalUnread = state.notifications[key].paging.totalUnread - 1;
      },
    };
  }
}
